// ZOHAAN Fresh Theme - Core JS
document.addEventListener('DOMContentLoaded', function() {
  // Wishlist (delegated — also covers buttons added later via JS)
  const wishlist = JSON.parse(localStorage.getItem('zohaan_wishlist') || '[]');
  updateWishBadges();

  function wishKey(x){ return String((typeof x === 'object' && x) ? (x.h || x.handle || x.u || '') : x); }
  document.querySelectorAll('.wish-btn').forEach(btn => {
    if (wishlist.map(wishKey).indexOf(String(btn.dataset.productId)) > -1) btn.classList.add('active');
  });
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.wish-btn');
    if (!btn || btn.closest('.wish-page')) return; // wishlist page manages its own hearts
    e.preventDefault();
    const id = String(btn.dataset.productId);
    const idx = wishlist.map(wishKey).indexOf(id);
    if (idx > -1) { wishlist.splice(idx, 1); btn.classList.remove('active'); }
    else { wishlist.push(id); btn.classList.add('active'); }
    localStorage.setItem('zohaan_wishlist', JSON.stringify(wishlist));
    updateWishBadges();
  });
  
  function updateWishBadges() {
    document.querySelectorAll('.wish-count').forEach(el => {
      el.textContent = wishlist.length;
      el.style.display = wishlist.length ? 'flex' : 'none';
    });
  }
  
  // Cart count
  fetch('/cart.js').then(r => r.json()).then(cart => {
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count ? 'flex' : 'none';
    });
  });
  
  // Quick add (delegated — covers buttons added later via JS; NO page reload)
  document.addEventListener('click', function(e) {
    if (e.defaultPrevented) return; // e.g. search page handles its own grid
    const btn = e.target.closest('.quick-add');
    if (!btn || btn.disabled) return;
    const id = btn.dataset.variantId;
    if (!id) return;
    e.preventDefault();
    btn.disabled = true;
    const orig = btn.innerHTML;
    btn.innerHTML = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({id: id, quantity: 1})
    })
    .then(r => { if (!r.ok) throw new Error('add failed'); return r.json(); })
    .then(() => fetch('/cart.js').then(r => r.json()))
    .then(cart => {
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count ? 'flex' : 'none';
        el.removeAttribute('hidden');
      });
      zhToast('Added to cart');
    })
    .catch(() => zhToast('Could not add to cart'))
    .finally(() => { btn.disabled = false; btn.innerHTML = orig; });
  });

  function zhToast(msg) {
    let t = document.getElementById('zh-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'zh-toast';
      t.setAttribute('role', 'status');
      t.style.cssText = 'position:fixed;left:50%;bottom:28px;transform:translateX(-50%) translateY(20px);background:#0B0B0B;color:#F2C94C;border:1px solid rgba(212,175,55,.5);padding:12px 22px;border-radius:999px;font-size:14px;font-weight:600;z-index:9999;opacity:0;transition:opacity .25s,transform .25s;pointer-events:none;box-shadow:0 8px 30px rgba(0,0,0,.4);white-space:nowrap;max-width:92vw;overflow:hidden;text-overflow:ellipsis;';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    requestAnimationFrame(() => { t.style.opacity = '1'; t.style.transform = 'translateX(-50%) translateY(0)'; });
    clearTimeout(t._hide);
    t._hide = setTimeout(() => { t.style.opacity = '0'; t.style.transform = 'translateX(-50%) translateY(20px)'; }, 2200);
  }
  
  // Quantity
  document.querySelectorAll('.qty').forEach(qty => {
    const input = qty.querySelector('input');
    qty.querySelector('.qty-minus').addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value) - 1);
    });
    qty.querySelector('.qty-plus').addEventListener('click', () => {
      input.value = parseInt(input.value) + 1;
    });
  });
  
  // Mobile menu
  const menuBtn = document.querySelector('.mobile-menu-btn');
  const mobileNav = document.querySelector('.mobile-nav');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', () => mobileNav.classList.toggle('open'));
  }
});
